import * as Yup from "yup";
import { itemSchema } from "../validations/validations";
import { countrySchema, existingAddressSchema, zipCodeSchema } from "./validations";
  
  const addressValidation = Yup.object().shape({
    country: countrySchema,
    zip: zipCodeSchema,
  });
  
  
  export const quoteSchema = Yup.object().shape({
    isExistingAddress: Yup.boolean(),
    from: addressValidation.when('isExistingAddress', {
      is: true,
      then: Yup.object().strip(),
      otherwise: addressValidation,
    }),
    to: addressValidation,
    item: itemSchema,
    selectedAddress: existingAddressSchema
  });